import { AffiliateUpdateQuoteProps } from '@commenda/types/src/quotes/types';
import { fetcher } from '@commenda/utils';

export async function updateQuote(
  // Affiliate firm to create a quote for:
  affiliateFirmId: string,
  quoteId: string,
  data: AffiliateUpdateQuoteProps
): Promise<Response | null> {
  try {
    const res = await fetcher(
      `affiliate-firms/${affiliateFirmId}/quotes/${quoteId}`,
      {
        method: 'PATCH',
        body: {
          ...data,
        },
      }
    );

    return res;
  } catch (err) {
    console.error(err);
    return null;
  }
}
